/* mobx store for Juicy sign up flow app. */
import {observable} from 'mobx';

const store = observable.map({stripeToken: null});

export default store;
